import { useTranslation } from 'react-i18next';

type GreetingKey =
  | 'greeting.goodMorning'
  | 'greeting.goodAfternoon'
  | 'greeting.goodEvening';

export const getGreetingKey = (hours: number): GreetingKey => {
  if (hours < 12) return 'greeting.goodMorning';
  if (hours < 18) return 'greeting.goodAfternoon';
  return 'greeting.goodEvening';
};

export const useGreeting = () => {
  const { t } = useTranslation();
  const hours = new Date().getHours();

  return t(getGreetingKey(hours));
};
